export default __webpack_public_path__ + "static/logo-bertoni-pro-af7304e0396f5d18b3e44b915f477be2.svg";